<template>
<FormItem :label="field.label" 
  v-click-outside="clickOutside"
>
  <div v-if="['textbox','text'].includes(field.type)">
      <Input
        v-if="canShowEditView && hasRequiredPermission(field)"
        v-model="value"
        :placeholder="`Enter `+ field.label"
      />
    <div v-else class="field-control text-left" @click="showEditView()">
        <div v-if="fieldValue" class="form-value">
          <Ellipsis
          :text="fieldValue"
          :length="25"
          />
        </div>
        <div v-else class="form-value d-block">Enter {{field.label}}</div>
    </div>
    <div class="action-edit"
        v-if="canShowEditView">
        <i class="text-grey-medium" @click="closeEditView()">
            <svgicon name="icon-close" width="8" height="8" />
        </i>
        <i class="text-blue" @click="saveEnteredValue">
            <svgicon name="icon-tick-sm" width="10" height="10" />
        </i>
    </div>
  </div>
  <div class="field-control" v-else-if="field.type == 'date'">
    <DatePicker
      v-model="value"
      @focus="showEditView()"
      type="datetime"
      :disabled="!hasRequiredPermission(field)"
      :clearable="false"
      format="dd-MM-yyyy hh:mmA"
      placeholder="Pick a date"
      size="small"
    />
    <div class="action-edit"
      v-if="canShowEditView">
      <i class="text-grey-medium" @click="closeEditView()">
          <svgicon name="icon-close" width="8" height="8" />
      </i>
      <i class="text-blue" @click="saveEnteredValue">
          <svgicon name="icon-tick-sm" width="10" height="10" />
      </i>
    </div>
  </div>
    <div class="field-control" v-else-if="field.type == 'dropdown'">
    <div class="dropdown-section">
     <Select default-first-option v-model="value" @focus="showEditView()" :disabled="!hasRequiredPermission(field)">
       <Option v-for="item in field.choices" :key="item" :label="item" :value="item" />
     </Select>
    </div>
    <div class="action-edit"
      v-if="canShowEditView">
      <i class="text-grey-medium" @click="closeEditView()">
          <svgicon name="icon-close" width="8" height="8" />
      </i>
      <i class="text-blue" @click="saveEnteredValue">
          <svgicon name="icon-tick-sm" width="10" height="10" />
      </i>
    </div>
  </div>
  </FormItem>
</template>
<script>
export default {
  props: ['field', 'fieldValue', 'orderNumber', 'isTransporter', 'orderStatus', 'isDestinationUser', 'isSourceUser'],
  data(){
    return {
      showActions: false,
      value: null,
      tempValue: null,
    }
  },
  computed: {
    canShowEditView() {
      if (this.field.custom_field_type === 'indent_source') {
        return this.showActions && this.isSourceUser;
      } else if (this.field.custom_field_type === 'indent_destination') {
        return this.showActions && this.isDestinationUser;
      }
      return this.showActions;
    },
  },
  created(){
    this.value = this.fieldValue;
  },
  methods:{
    closeEditView() {
      this.showActions = false;
      this.value = this.tempValue;
    },
    hasValidStatusToEdit(field) {
      const disableEditOnStatus = field.disable_edit_on_status ? field.disable_edit_on_status.map(status => Number(status)) : [];
      const isValidEditStatus = !field.disable_edit_on_status || !disableEditOnStatus.includes(Number(this.orderStatus));
      return isValidEditStatus;
    },
    hasRequiredPermission(field) {
      if (this.isTransporter) {
        return (this.field.editable_to_transporter && this.hasValidStatusToEdit(field)) || false;
      }
      return (this.$hasPermission(field.permission) || this.$hasCustomFieldPermission(field.permission)) && this.hasValidStatusToEdit(field);
    },
    showEditView() {
      const name = this.field.name;
      if(this.hasRequiredPermission(this.field)){
        this.showActions = true;
        this.currentSelected = name;
        this.tempValue = this.fieldValue;
      }
    },
    async saveEnteredValue() {
      const payloadName = this.field.name;
      const payload = {
        name: payloadName,
        value: this.value,
      };
      const orderNo = this.orderNumber;
      const result = await this.$store.dispatch(`${this.isTransporter ? 'indents' : 'order'}/customFieldsMono`,
        { payload, orderNo });
      if (result === 'Accepted') {
        this.tempValue = this.value;
        this.$emit('updateFieldValue', this.value);
        this.$success({ message: `${this.field.label} is updated` });
        this.closeEditView();
      } else {
        this.$error({ message: result.error });
      }
    },
    clickOutside() {
      this.showActions = false;
      this.value = this.fieldValue;
    },
  }
}
</script>